<template>
    <div class="payment-processing">
        <h1>Secure Payment</h1>
        <div class="square-container">
            <iframe
                :src="squareCheckoutUrl"
                title="Square Checkout"
                class="square-iframe"
                allow="payment"
            ></iframe>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PaymentProcessing',
    data() {
        return {
            squareCheckoutUrl: 'https://square.link/u/qA5mSIef'
        };
    }
};
</script>

<style scoped>
.payment-processing {
    max-width: 700px;
    margin: 2rem auto;
    padding: 2rem;
    border: 1px solid #eee;
    border-radius: 8px;
    background: #fafafa;
    text-align: center;
}

.payment-processing h1 {
    margin-bottom: 1.5rem;
}

.square-container {
    overflow: hidden;
    border-radius: 6px;
}

.square-iframe {
    width: calc(100% + 20px);
    height: 800px;
    border: none;
}
</style>
